module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_lauerz-439d7fb11eaf1679193f9920b99f78d5.png";